var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reply-item-wrapper"},[_c('TextLinkContent',{attrs:{"data":_vm.data,"placeholder":_vm.placeholder},on:{"inputChange":_vm.inputChange}}),_c('span',{staticClass:"reply-type"},[_vm._v(_vm._s(_vm.replyType))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }